import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ActionDrawerItems,
  DrawerList,
  Header,
  HeaderProps,
  Icon,
} from 'barte-design-system';
import { SignOut } from '@phosphor-icons/react';
import { usePrototypeRole } from '../../access/role';
import './AppHeader.css';

/**
 * Wrapper do Header do DS. No papel interno, adiciona navegação para a página inicial ao
 * clicar no logo e um dropdown no avatar com a opção "Sair". No papel cliente, repassa as
 * props sem alterar nada — o header fica idêntico ao que o participante do teste já viu.
 */
export function AppHeader(props: HeaderProps) {
  const { role, logout } = usePrototypeRole();
  const navigate = useNavigate();

  if (role !== 'internal') {
    return (
      <div className="app-header-wrapper">
        <Header {...props} />
      </div>
    );
  }

  return (
    <div className="app-header-wrapper">
      <Header
        {...props}
        avatarDrawerContent={
          props.avatarDrawerContent ?? (
            <DrawerList>
              <ActionDrawerItems
                items={[
                  {
                    label: 'Sair',
                    variant: 'icon',
                    icon: <Icon icon={SignOut} size={16} weight="regular" />,
                    onClick: logout,
                  },
                ]}
              />
            </DrawerList>
          )
        }
      />
      <div
        className="app-header-logo-overlay"
        onClick={() => navigate('/')}
        role="button"
        aria-label="Ir para a página inicial"
        tabIndex={0}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') navigate('/');
        }}
      />
    </div>
  );
}
